<template>
    <app-layer
        ref="app"
        :breadcrumbs="currentBreadcrumbs.concat(breadcrumbs)"
        :header-space="headerSpace"
    >
        <template #header>
          <slot name="header" />
        </template>
        <data-container :loading="loading" :error="error" @retry="getProperty">
            <v-container v-if="!property">
                <div class="text-center grey--text">
                    <p>We could not find that property or you do not have access to it</p>
                </div>
            </v-container>
            <slot v-else v-bind="{ property }">
              <v-row
                  align="center"
                  justify="center"
              >
                <v-col class="text-center" cols="12" md="6">
                  <v-avatar color="primary" size="150">
                    <v-img
                        :src="property.image"
                    ></v-img>

                  </v-avatar>
                  <div class="d-flex justify-center align-center">
                    <h1>{{ property.name }}</h1>
                    <v-btn v-if="property.access" icon title="Property Settings" color="primary" class="ml-3" @click="$router.push({name: 'property.settings', params: { property: property.id }})">
                      <v-icon>mdi-cog</v-icon>
                    </v-btn>
                  </div>
                  <p>{{ property.address }}</p>
                  <v-icon color="white" v-if="property.phone">mdi-phone</v-icon> {{ property.phone }}
                  <br>
                  <v-icon color="white" v-if="property.email">mdi-email</v-icon>  {{ property.email }}
                </v-col>
              </v-row>
            </slot>
        </data-container>
    </app-layer>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';

import AppLayer from '@/AppLayer';
import DataContainer from '../../../components/DataContainer.vue';
import GET_PROPERTY from '../Queries/getProperty';

export default {
    name: 'Property',
    components: {
        AppLayer, DataContainer
    }, 
    data(){
        return {
            loading: false,
            error: null,
            property: null,
        }
    },
    props: {
      breadcrumbs: Array,
      headerSpace: Number
    },
    computed:{
      ...mapGetters([
          'current_user',
          'properties',
      ]),
       id(){
          return this.$route.params.property;
      },
      currentBreadcrumbs(){
        return [
          {
            text: "Properties",
            to: { name: 'property.list' }
          },
          {
            text: this.property?.name || this.id,
            to: { name: 'property.show', params: { property: this.id } }
          },
        ]
      }
    },
    methods:{
        ...mapActions([
            'query',
            'mutate',
        ]),
        ...mapMutations([
            'SET_ACTIVE_PROPERTY',
            'SET_MODE'
        ]),

        getProperty(){
            this.loading = true;
            this.query({
                query: GET_PROPERTY,
                variables: {
                    id: this.id
                }
            })
            .then(response => {
                const property = response?.data?.getPropertyById;
                if(property) {
                  const propertyInAuth = this.properties.find(p => p.id === property.id);
                  if(propertyInAuth) {
                    this.SET_ACTIVE_PROPERTY(propertyInAuth);
                    this.SET_MODE('host');
                    this.property = property;
                  }
                }
            })
            .catch(e => this.error = e)
            .finally(() => {
                this.loading = false;
            })
        }
    },
    watch: {
      id: {
        immediate: true,
        handler(id) {
          if(id) this.getProperty();
        }
      }
    }
}
</script>
